import { Platform } from "react-native";
import * as SecureStore from "expo-secure-store";

const LOCALE_KEY = "user_locale_preference";

function getWebStorage(): Storage | null {
  if (typeof localStorage === "undefined") {
    return null;
  }
  if (
    typeof localStorage.getItem !== "function"
    || typeof localStorage.setItem !== "function"
  ) {
    return null;
  }
  return localStorage;
}

/**
 * Platform-aware locale persistence.
 * - Web: localStorage (SecureStore's native module is unavailable on web)
 * - Native: expo-secure-store
 */
export const localeStorage = {
  async get(): Promise<string | null> {
    if (Platform.OS === "web") {
      const storage = getWebStorage();
      try {
        return storage ? storage.getItem(LOCALE_KEY) : null;
      } catch {
        // Safari private mode or storage disabled — silently fall back to no preference.
        return null;
      }
    }
    return SecureStore.getItemAsync(LOCALE_KEY);
  },

  set(locale: string): void {
    if (Platform.OS === "web") {
      const storage = getWebStorage();
      try {
        if (storage) storage.setItem(LOCALE_KEY, locale);
      } catch {
        // Safari private mode or storage quota exceeded — silently no-op.
      }
      return;
    }
    SecureStore.setItemAsync(LOCALE_KEY, locale).catch(() => {
      // Non-critical — locale falls back to default on next launch
    });
  },
};
